function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useCallback, useMemo } from 'react';
import { PublishedStatusChip } from '@applyboard/business-ui-legacy';
import { Divider, Gallery, Box, Typography, Link, GRAY } from '@applyboard/ui-components';
import { ApplyBoardOutlineIcon, CertifiedOutlineIcon, DocumentCheckOutlineIcon, EditOutlineIcon, FireOutlineIcon, MoneyOutlineIcon, PassportOutlineIcon, RefundOutlineIcon, StarOutlineIcon, SuitcaseOutlineIcon, PersonCheckOutlineIcon, DollarSignCheckOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { Flex, Tooltip, Tag } from '@applyboard/crystal-ui';
import { displayDesktopOnly, displayMobileOnly, mobileBottomBorder } from "../../consts";
import { SmallSchoolSummary } from "./SmallSchoolSummary";
import { ProgramWebsiteLink } from "./style";
var ICONS_MAP = {
  ApplyBoardOutlineIcon: ApplyBoardOutlineIcon,
  CertifiedOutlineIcon: CertifiedOutlineIcon,
  DocumentCheckOutlineIcon: DocumentCheckOutlineIcon,
  MoneyOutlineIcon: MoneyOutlineIcon,
  PassportOutlineIcon: PassportOutlineIcon,
  RefundOutlineIcon: RefundOutlineIcon,
  StarOutlineIcon: StarOutlineIcon,
  SuitcaseOutlineIcon: SuitcaseOutlineIcon,
  PersonCheckOutlineIcon: PersonCheckOutlineIcon,
  DollarSignCheckOutlineIcon: DollarSignCheckOutlineIcon,
  "default": FireOutlineIcon
};
function getIcon(iconName) {
  return ICONS_MAP[iconName] || ICONS_MAP['default'];
}
export function SchoolHeader(_ref) {
  var programName = _ref.programName,
    schoolName = _ref.schoolName,
    countryCode = _ref.countryCode,
    city = _ref.city,
    state = _ref.state,
    logo = _ref.logo,
    to = _ref.to,
    images = _ref.images,
    video = _ref.video,
    editLink = _ref.editLink,
    isProgramPublished = _ref.isProgramPublished,
    lastUpdated = _ref.lastUpdated,
    cover = _ref.cover,
    coverFallback = _ref.coverFallback,
    programId = _ref.programId,
    programWebsite = _ref.programWebsite,
    programTags = _ref.programTags;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var trackViewPhoto = useCallback(function (_ref2) {
    var photoFileName = _ref2.photoFileName,
      photoNumber = _ref2.photoNumber;
    return trackEvent({
      event: "Programs Page - Clicked 'View Photos'",
      data: {
        fileName: photoFileName,
        photoNumber: photoNumber
      }
    });
  }, [trackEvent]);
  var EditLink = function EditLink(_ref3) {
    var editLink = _ref3.editLink;
    return /*#__PURE__*/React.createElement(React.Fragment, null, editLink && /*#__PURE__*/React.createElement(Link, {
      href: editLink,
      target: "_blank",
      "aria-label": "edit"
    }, /*#__PURE__*/React.createElement(EditOutlineIcon, null)));
  };
  var ProgramName = function ProgramName(_ref4) {
    var programName = _ref4.programName;
    return /*#__PURE__*/React.createElement(Typography, {
      role: "heading",
      variant: "h1",
      mr: 5,
      style: {
        color: GRAY[5]
      }
    }, programName);
  };
  var ProgramId = function ProgramId(_ref5) {
    var programId = _ref5.programId;
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        color: GRAY[10]
      }
    }, programId);
  };
  var LastUpdated = function LastUpdated(_ref6) {
    var lastUpdated = _ref6.lastUpdated;
    return /*#__PURE__*/React.createElement(React.Fragment, null, lastUpdated && /*#__PURE__*/React.createElement(Divider, {
      orientation: "vertical",
      flexItem: true
    }), lastUpdated && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        color: GRAY[10]
      }
    }, "Last reviewed at: ", new Date(lastUpdated).toUTCString()));
  };
  var LinkToProgramWebsite = function LinkToProgramWebsite(_ref7) {
    var websiteLink = _ref7.websiteLink;
    return /*#__PURE__*/React.createElement(React.Fragment, null, websiteLink && /*#__PURE__*/React.createElement(Divider, {
      orientation: "vertical",
      flexItem: true
    }), websiteLink && /*#__PURE__*/React.createElement(ProgramWebsiteLink, {
      href: websiteLink,
      rel: "external noopener",
      target: "_blank"
    }, "view official school website"));
  };
  var ProgramTags = function ProgramTags(_ref8) {
    var programTags = _ref8.programTags;
    // Sort tags to show featured first, then non-featured, and by order within each group
    var sortedTags = useMemo(function () {
      if (!programTags || programTags.length === 0) {
        return [];
      }
      return _toConsumableArray(programTags).sort(function (a, b) {
        // First, sort by featured status (featured first)
        if (a.isFeatured !== b.isFeatured) {
          return a.isFeatured ? -1 : 1;
        }
        // Then sort by order within each group
        return a.order - b.order;
      });
    }, [programTags]);
    return /*#__PURE__*/React.createElement(Flex, {
      direction: "row",
      gap: 1,
      wrap: true
    }, sortedTags === null || sortedTags === void 0 ? void 0 : sortedTags.map(function (tag) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        key: tag.name,
        label: tag.description,
        placement: "bottom",
        onOpenChange: function onOpenChange(open) {
          if (open) {
            trackEvent({
              event: 'Programs Page - Viewed tooltip on program tag',
              data: {
                program_id: programId,
                program_name: programName,
                tag_description: tag.description,
                tag_display_name: tag.displayName,
                tag_name: tag.name
              }
            });
          }
        }
      }, /*#__PURE__*/React.createElement(Tag, {
        as: "button",
        icon: getIcon(tag.iconName),
        intent: tag.intent,
        size: "sm"
      }, tag.displayName));
    }));
  };
  return /*#__PURE__*/React.createElement(Box, {
    pb: 5,
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(SmallSchoolSummary, {
    schoolName: schoolName,
    countryCode: countryCode,
    city: city,
    state: state,
    logo: logo,
    to: to,
    cover: cover,
    coverFallback: coverFallback
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 5,
    mx: {
      xs: 3,
      md: 0
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    gap: 1
  }, /*#__PURE__*/React.createElement(PublishedStatusChip, {
    published: isProgramPublished,
    chipProps: {
      mr: 5
    }
  }), /*#__PURE__*/React.createElement(EditLink, {
    editLink: editLink
  })), /*#__PURE__*/React.createElement(ProgramName, {
    programName: programName
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    mx: {
      xs: 3,
      md: 0
    },
    display: displayMobileOnly
  }, /*#__PURE__*/React.createElement(ProgramTags, {
    programTags: programTags || []
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    mx: {
      xs: 3,
      md: 0
    },
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    gap: 4
  }, /*#__PURE__*/React.createElement(ProgramId, {
    programId: programId
  }), /*#__PURE__*/React.createElement(LastUpdated, {
    lastUpdated: lastUpdated
  }), /*#__PURE__*/React.createElement(LinkToProgramWebsite, {
    websiteLink: programWebsite
  }), /*#__PURE__*/React.createElement(React.Fragment, null, (programTags === null || programTags === void 0 ? void 0 : programTags.length) > 0 && /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    flexItem: true
  }), /*#__PURE__*/React.createElement(ProgramTags, {
    programTags: programTags || []
  })))), /*#__PURE__*/React.createElement(Box, {
    mt: 5,
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(Gallery, {
    images: images,
    video: video,
    onViewPhoto: trackViewPhoto
  })));
}